const get = require('lodash/get')

module.exports = ['$q', '$translate', '$utils',
  function ($q, $translate, $utils) {
    /**
     *  http 状态拦截，主要对返回状态码进去相应的业务处理
     * */
    return {
      responseHandler: {},
      response: function (oUser, options, reason) {
        if (~[0, -1].indexOf(reason.status)) { // handle for no network
          $utils.$notify.set({message: $translate.instant('TIPS.BAD_NETWORK')})
          const data = reason.data || reason
          data.code = 'FA_BAD_NETWORK'
          return $q.reject(data)
        }

        if (reason.status === 500) { // handle for server error
          $utils.$notify.set({message: $translate.instant('TIPS.SERVER_ERROR')})
          return $q.reject(reason.data)
        }

        // handle for reason code
        let code = get(reason, 'data.code')
        !oUser.sid && (code = 'FA_INVALID_SESSION') // 特殊处理，sid不存在直接过期
        const responseHandler = this.responseHandler
        return responseHandler[code] ? responseHandler[code](options, reason) : $q.reject(reason.data)
      }
    }
  }]



// WEBPACK FOOTER //
// ./src/js/services/httpInterceptor.js